import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { CheckCircle2, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
export function SafesAccessories() {
  useDocumentMeta('Gun Safes, Cases & Shooting Accessories | Kjergaard Sports', 'Shop gun safes, cases, holsters, cleaning supplies, magazines, targets, and shooting accessories at Kjergaard Sports in Lake Benton, Minnesota.');
  const categories = ['Safes', 'Cases', 'Holsters', 'Cleaning supplies', 'Magazines', 'Rests', 'Targets', 'Maintenance items', 'Shooting accessories'];
  return <div data-id="element-505">
      <PageHero title="Gun Safes, Cases & Shooting Accessories" image="https://cdn.magicpatterns.com/uploads/esrRsJE1XbS5zcQi7PgR9E/safes-display.jpg" alt="Gun safes and secure storage at Kjergaard Sports" data-id="element-506" />

      <section className="py-20 bg-brand-offwhite" data-id="element-507">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-508">
          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-509">
            <div data-id="element-510">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-511">
                Secure Storage & Essential Gear
              </h2>
              <p className="text-lg text-brand-charcoal/80 mb-6 leading-relaxed" data-id="element-512">
                Protecting your investment and maintaining your equipment is
                just as important as the firearm itself. Kjergaard Sports
                carries a robust selection of heavy-duty gun safes, secure
                transport cases, and everyday maintenance accessories.
              </p>

              <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream mb-8" data-id="element-513">
                <h3 className="font-serif text-xl mb-4" data-id="element-514">
                  Our Accessory Selection Includes:
                </h3>
                <ul className="grid sm:grid-cols-2 gap-3" data-id="element-515">
                  {categories.map((item, index) => <li key={index} className="flex items-start" data-id="element-516">
                      <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-2 flex-shrink-0 mt-0.5" data-id="element-517" />
                      <span className="text-brand-charcoal/90" data-id="element-518">{item}</span>
                    </li>)}
                </ul>
              </div>

              <Link to="/contact" className="inline-flex bg-brand-hunter hover:bg-brand-wood text-brand-offwhite px-8 py-4 rounded-sm font-medium transition-colors items-center" data-id="element-519">
                <MapPin className="w-5 h-5 mr-2" data-id="element-520" />
                Plan Your Visit
              </Link>
            </div>

            <div data-id="element-521">
              <img src="https://cdn.magicpatterns.com/uploads/jwChz1kho8pae8NFhrqrQH/accessories-wall.jpg" alt="Safes and accessories at Kjergaard Sports" className="w-full h-auto rounded-sm shadow-lg object-cover" data-id="element-522" />
            </div>
          </div>
        </div>
      </section>
    </div>;
}